module.exports = __webpack_public_path__ + "static/media/KegOrders.3fe9ddb7.svg";